import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withArrow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#7BA99E] text-white hover:bg-[#5A8075] shadow-md hover:shadow-lg focus:ring-[#7BA99E]',
    secondary: 'bg-[#4A4238] text-[#FAF7F2] hover:bg-[#2C2721] shadow-md hover:shadow-lg focus:ring-[#4A4238]',
    outline: 'border-2 border-[#4A4238] text-[#4A4238] hover:bg-[#4A4238] hover:text-[#FAF7F2] focus:ring-[#4A4238]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-165">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-166" />}
    </button>;
}